<template>
	<div class="home">
		<!-- <section class="hero is-medium is-primary is-bold">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">Resp IoT</h1>
        </div>
      </div>
    </section> -->
		<div class="wave">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
				<defs>
					<linearGradient id="grad1" x1="100%" y1="0%" x2="0%" y2="0%">
						<stop offset="0%" style="stop-color: #6b95ff; stop-opacity: 1" />
						<stop offset="100%" style="stop-color: #28ffff; stop-opacity: 1" />
					</linearGradient>
				</defs>
				<path
					fill="url(#grad1)"
					fill-opacity="1"
					d="M0,192L30,170.7C60,149,120,107,180,106.7C240,107,300,149,360,154.7C420,160,480,128,540,122.7C600,117,660,139,720,149.3C780,160,840,160,900,181.3C960,203,1020,245,1080,272C1140,299,1200,309,1260,288C1320,267,1380,213,1410,186.7L1440,160L1440,0L1410,0C1380,0,1320,0,1260,0C1200,0,1140,0,1080,0C1020,0,960,0,900,0C840,0,780,0,720,0C660,0,600,0,540,0C480,0,420,0,360,0C300,0,240,0,180,0C120,0,60,0,30,0L0,0Z"
				></path>
			</svg>
		</div>
		<div class="title primary is-txt-accent-dark">Resp IoT</div>
		<div class="">
			<div class="px-5 py-4 has-text-centered">
				<div class="py-4">
					<label class="checkbox">
						<input type="checkbox" v-model="isRequestingAccessDoctor" />
						Soy Doctor
					</label>

					<transition name="scale">
						<div v-if="isRequestingAccessDoctor">
							<div class="field">
								<label class="label keyword-prompt has-text-left"
									>Ingresa la clave de seguridad para confirmar proceder con el
									inicio de sesión</label
								>
								<div class="control">
									<input
										class="input"
										type="text"
										v-model="keyword"
										placeholder="clave de seguridad"
									/>
								</div>
							</div>
							<div>
								<button class="button is-bg-primary" :class="{ 'is-loading': isVerifyingDoctor }" @click="verifyIsDoctor">
									Verificar
								</button>
							</div>
						</div>
					</transition>
				</div>
				<button
					class="button is-txt-primary is-outlined"
					@click="doGmailLogin()"
				>
					Inicia Sesión con Gmail
				</button>

				
			</div>
			<!-- <div><button @click="logout()">logout</button></div> -->
		</div>
	</div>
</template>

<script lang="ts">
	import { UserType } from "@/domain/entities/UserTypes";
	import AuthFacade from "@/infraestructure/auth/auth_facade";
	import useNotification from "@/store/NotificationState";
	import useAuth from "@/store/AuthState";
	import { defineComponent, reactive, inject, ref } from "vue";
	import { useRouter } from "vue-router";

	export default defineComponent({
		name: "Login",

		setup() {
			const authFacade: AuthFacade = inject(AuthFacade.key) as AuthFacade;
			const { signIn, verifyDoctor } = useAuth();
			const { showSnackbar, SnackbarMessageLevel } = useNotification();
			const router = useRouter();
			const isRequestingAccessDoctor = ref(false);
			let isDoctorConfirmed = false;

			interface LoginPayload {
				email: string;
				password: string;
			}
			const loginPayload: LoginPayload = { email: "", password: "" };
			const loginState = reactive(loginPayload);

			async function doGmailLogin() {
				// this.email
				// this.password
				try {
					if (isRequestingAccessDoctor.value === false) {
						await signIn(UserType.Patient);
					} else if (
						isRequestingAccessDoctor.value === true &&
						isDoctorConfirmed
					) {
						await signIn(UserType.Doctor);
					}
					router.push({ name: "dashboard" });
				} catch (error) {
					console.error(error);
				}
			}

			async function logout() {
				await authFacade?.logout();
			}

			const keyword = ref<string>("");
			const isVerifyingDoctor = ref(false)
			const verifyIsDoctor = async () => {
				if (keyword.value === "") {
					showSnackbar("Ingresa la clave");
					return;
				}
				isVerifyingDoctor.value = true
				let responseIsDoctor: boolean = await verifyDoctor(keyword.value);
				isVerifyingDoctor.value = false
				showSnackbar(
					responseIsDoctor
						? "acceso otorgado"
						: "clave incorrecta. acceso cancelado",
					{
						level: responseIsDoctor
							? SnackbarMessageLevel.INFO
							: SnackbarMessageLevel.DANGER,
					}
				);
				if (!responseIsDoctor) {
					isDoctorConfirmed = false;
					keyword.value = "";
				} else {
					isDoctorConfirmed = true;
				}
			};
			return {
				loginState,
				doGmailLogin,
				logout,
				isRequestingAccessDoctor,
				keyword,
				verifyIsDoctor,
				isVerifyingDoctor,
			};
		},
	});
</script>

<style lang="stylus" scoped>
	@import '../styles/colors.styl';

	background = linear-gradient(-90deg, #6b95ff, #28ffff);

	.home {
		display: grid;
		grid-template-rows: 100px min-content minmax(min-content, max-content);
		min-height: 100vh;

		@media screen and (min-width: 500px) {
			grid-template-rows: 300px min-content auto;
		}
	}

	.title {
		align-self: center;
		height: 100%;
		margin: 18px 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.scale-enter-active {
		animation: scale-in 0.5s;
	}

	.scale-leave-active {
		animation: scale-in 0.5s reverse;
	}

	@keyframes scale-in {
		0% {
			transform: scale(0);
		}

		100% {
			transform: scale(1);
		}
	}
</style>
